/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppLedgerRouteImport } from './routes/app.ledger'
import { Route as AppSettingsRouteImport } from './routes/app.settings'
import { Route as AppStatsRouteImport } from './routes/app.stats'
import { Route as AppTimingRouteImport } from './routes/app.timing'
import { Route as SSlugRouteImport } from './routes/s.$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppLedgerRoute = AppLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppStatsRoute = AppStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppRoute,
} as any)
const AppTimingRoute = AppTimingRouteImport.update({
  id: '/timing',
  path: '/timing',
  getParentRoute: () => AppRoute,
} as any)
const SSlugRoute = SSlugRouteImport.update({
  id: '/s/$slug',
  path: '/s/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/app/ledger': typeof AppLedgerRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/stats': typeof AppStatsRoute
  '/app/timing': typeof AppTimingRoute
  '/s/$slug': typeof SSlugRoute
  '/app/': typeof AppIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/app/ledger': typeof AppLedgerRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/stats': typeof AppStatsRoute
  '/app/timing': typeof AppTimingRoute
  '/s/$slug': typeof SSlugRoute
  '/app': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/app/ledger': typeof AppLedgerRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/stats': typeof AppStatsRoute
  '/app/timing': typeof AppTimingRoute
  '/s/$slug': typeof SSlugRoute
  '/app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/register'
    | '/app/ledger'
    | '/app/settings'
    | '/app/stats'
    | '/app/timing'
    | '/s/$slug'
    | '/app/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/app/ledger'
    | '/app/settings'
    | '/app/stats'
    | '/app/timing'
    | '/s/$slug'
    | '/app'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/register'
    | '/app/ledger'
    | '/app/settings'
    | '/app/stats'
    | '/app/timing'
    | '/s/$slug'
    | '/app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  SSlugRoute: typeof SSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/ledger': {
      id: '/app/ledger'
      path: '/ledger'
      fullPath: '/app/ledger'
      preLoaderRoute: typeof AppLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/stats': {
      id: '/app/stats'
      path: '/stats'
      fullPath: '/app/stats'
      preLoaderRoute: typeof AppStatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/timing': {
      id: '/app/timing'
      path: '/timing'
      fullPath: '/app/timing'
      preLoaderRoute: typeof AppTimingRouteImport
      parentRoute: typeof AppRoute
    }
    '/s/$slug': {
      id: '/s/$slug'
      path: '/s/$slug'
      fullPath: '/s/$slug'
      preLoaderRoute: typeof SSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRouteChildren {
  AppLedgerRoute: typeof AppLedgerRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStatsRoute: typeof AppStatsRoute
  AppTimingRoute: typeof AppTimingRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLedgerRoute: AppLedgerRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStatsRoute: AppStatsRoute,
  AppTimingRoute: AppTimingRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  SSlugRoute: SSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
